<template>
  <el-dialog
    v-model="visible"
    title="Nuevo recurso"
    width="60%"
    center
    @close="closeModal"
  >
    <el-row
      :gutter="24"
      class="input-margin"
    >
      <custom-input
        v-model="recurso.Descripcion"
        :label="'Descripción'"
        :spanColumn="10"
        :settings="{
          placeholder: 'Ingresar descripción',
          inputClass: { 'input-error': !validateResourceFields.Descripcion },
        }"
      ></custom-input>
      <custom-input
        v-model="recurso.CodigoRenglonEquivalente"
        :label="'Código renglón equivalente'"
        :spanColumn="8"
        :settings="{
          placeholder: 'Ingresar código',
          maxlength: 50,
          showWordLimit: true,
        }"
      ></custom-input>
      <el-col :span="5">
        <div class="custom-label">Activo</div>
        <el-switch
          v-model="recurso.Activo"
          active-text="Si"
          inactive-text="No"
          class="mb-2"
          sieze="large"
        />
      </el-col>
    </el-row>
    <el-row class="input-margin">
      <el-col :span="6">
        <custom-select
          v-model="recurso.Moneda"
          :label="'Moneda'"
          :settings="{
            placeholder: 'Seleccionar moneda',
            options: monedaList,
          }"
        >
        </custom-select>
      </el-col>
      <el-col
        :span="6"
        style="margin-left: 2%; margin-right: 2%"
      >
        <custom-select
          v-model="recurso.RecursoTipo"
          :label="'Tipo recurso'"
          :settings="{
            inputClass: { 'input-error': !validateResourceFields.RecursoTipo },
            options: recursoTipoList,
          }"
          @update:modelValue="handleRecursoTipoChange"
        >
        </custom-select>
      </el-col>
      <custom-input-number
        v-model="recurso.CostoHora"
        :label="labelCostoHora"
        :spanColumn="6"
        :settings="{
          placeholder: `Costo ${unidadTiempo}`,
          min: 0,
          precision: 2,
          step: 0.01,
          controls: false,
        }"
      >
      </custom-input-number>
    </el-row>
    <el-row
      :gutter="24"
      class="input-margin"
    >
      <custom-input-number
        v-model="recurso.TiempoPreparacionColor"
        :label="labelTiempoPreparacionColor"
        :spanColumn="7"
        :settings="{
          placeholder: `Tiempo preparación color (${unidadTiempo})`,
          min: 0,
          precision: 2,
          step: 0.01,
          controls: false,
        }"
      >
      </custom-input-number>
      <custom-input-number
        v-model="recurso.TiempoPolimero"
        :label="labelTiempoPolimero"
        :spanColumn="7"
        :settings="{
          placeholder: labelTiempoPolimero,
          min: 0,
          precision: 2,
          step: 0.01,
          controls: false,
        }"
      >
      </custom-input-number>
      <custom-input-number
        v-model="recurso.CantidadColor"
        :label="labelCantidadColor"
        :spanColumn="7"
        :settings="{
          placeholder: `Merma por cambio de color (${unidadMedida})`,
          min: 0,
          precision: 2,
          step: 0.01,
          controls: false,
        }"
      >
      </custom-input-number>
    </el-row>
    <el-row
      :gutter="24"
      class="input-margin"
    >
      <custom-input-number
        v-model="recurso.MermaPolimero"
        :label="labelMermaPolimero"
        :spanColumn="7"
        :settings="{
          placeholder: labelMermaPolimero,
          min: 0,
          precision: 2,
          step: 0.01,
          controls: false,
        }"
      >
      </custom-input-number>
      <custom-input-number
        v-model="recurso.AnchoMaximo"
        :label="'Ancho máximo'"
        :spanColumn="4"
        :settings="{
          placeholder: `Ancho máximo`,
          min: 0,
          precision: 2,
          step: 0.01,
          controls: false,
        }"
      />
      <custom-input-number
        v-if="esImpresora"
        v-model="recurso.CantidadCuerposImpresores"
        label="Cantidad de cuerpos impresores"
        :spanColumn="7"
        :settings="{
          placeholder: 'Cantidad máx. de cuerpos',
          min: 0,
          precision: 0,
          step: 1,
          controls: false,
        }"
      />
    </el-row>
    <el-row
      :gutter="24"
      class="input-margin"
    >
      <el-col :span="8">
        <div class="custom-label">Cargar imagen (opcional)</div>
        <el-upload
          class="upload-demo"
          :auto-upload="false"
          :limit="1"
          accept="image/png,image/jpeg,image/webp"
          :on-change="onFileChange"
          :on-remove="onFileRemove"
          :file-list="fileList"
          :before-upload="() => false"
        >
          <el-button
            type="primary"
            size="default"
            >Seleccionar imagen</el-button
          >
        </el-upload>
        <div
          v-if="previewUrl"
          style="margin-top: 8px"
        >
          <img
            :src="previewUrl"
            style="max-width: 100%; max-height: 160px; border: 1px solid #ddd; border-radius: 6px"
          />
        </div>
      </el-col>
    </el-row>
    <template v-slot:footer>
      <span class="dialog-footer">
        <el-button
          type="primary"
          @click="saveResource"
          >Guardar</el-button
        >
        <el-button @click="closeModal">Cancelar</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {
  ref,
  computed,
  onBeforeMount,
} from 'vue';
import { storeToRefs } from 'pinia';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import CustomSelect from '@/shared/components/custom_select.vue';
import { useRecursoStore } from '@/stores/recurso_store.js';
import recursoTipoService from '@/services/recurso_tipo_service.js';
import {
  resolverLabelsMatrizImpresion,
  conUnidad,
} from '@/shared/utils/label_matriz_impresion.js';
import { useMonedaStore } from '@/stores//moneda/moneda_store';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useLoading } from '@/shared/composables/loading.js';
import { ElNotification } from 'element-plus';
import { esRecursoImpresora } from '@/shared/composables/useCuerpoImpresor.js';

const recursoStore = useRecursoStore();
const monedaStore = useMonedaStore();

const { resetResource, newResourceHTTP, validarCampos, resetValidations, firstRecurso } =
  recursoStore;
const { recurso, validateResourceFields } = storeToRefs(recursoStore);
const recursoTipoList = ref([]);
const { monedaList } = storeToRefs(monedaStore);
const { firstMoneda } = monedaStore;

const visible = ref(false);

const unidadMedida = computed(() => recurso.value.RecursoTipo?.UnidadMedida?.Descripcion || '');
const unidadTiempo = computed(() => recurso.value.RecursoTipo?.UnidadTiempo?.Descripcion || '');
const esImpresora = computed(() => esRecursoImpresora(recurso.value.RecursoTipo));
const labelCostoHora = computed(() => `Costo ${unidadTiempo.value}`);
// const labelMetrosPreparacion = computed(() => `${unidadMedida.value} Preparación`)
// const labelPromedioProduccion = computed(() => `Promedio producción (${unidadTiempo.value})`)
// const labelTiempoPreparacionFijo = computed(() => `Tiempo preparación fijo (${unidadTiempo.value})`)
const labelTiempoPreparacionColor = computed(
  () => `Tiempo preparación color (${unidadTiempo.value})`,
);
// COTI-502: Determinar label para polimero
const labelsMatriz = computed(() => resolverLabelsMatrizImpresion(recurso.value.RecursoTipo));
const labelTiempoPolimero = computed(() =>
  conUnidad(labelsMatriz.value.tiempo, unidadTiempo.value),
);
const labelCantidadColor = computed(
  () => `Merma por cambio de color (${unidadMedida.value ?? 'UM'})`,
);
const labelMermaPolimero = computed(() =>
  conUnidad(labelsMatriz.value.merma, unidadMedida.value || 'UM'),
);
// const labelPromedioProduccionTroquelado = computed(() => `Promedio producción troquelado (${unidadTiempo.value})`)

const file = ref(null);
const fileList = ref([]);
const previewUrl = ref('');

function onFileChange(fileEvt, fileListEvt) {
  file.value = fileEvt?.raw || null;
  fileList.value = fileListEvt;
  if (file.value) {
    const url = URL.createObjectURL(file.value);
    previewUrl.value = url;
  } else {
    previewUrl.value = '';
  }
}
function onFileRemove() {
  file.value = null;
  fileList.value = [];
  previewUrl.value = '';
}

function handleRecursoTipoChange(item) {
  recurso.value.CodigoRecursoTipo = item.Codigo;
  if (!esRecursoImpresora(item)) recurso.value.CantidadCuerposImpresores = null;
}

const emit = defineEmits(['closed']);

const closeModal = () => {
  resetResource();
  resetValidations();
  onFileRemove();
  visible.value = false;
  emit('closed');
};

onBeforeMount(async () => {
  firstMoneda();
  const res = await recursoTipoService.findAll({ page: 1 });
  if (res?.data) recursoTipoList.value = res.data;
});

const saveResource = async () => {
  if (!validarCampos()) {
    ElNotification({
      title: 'Recurso',
      message: 'Por favor, completar los campos obligatorios',
      type: 'warning',
    });
    return;
  } else {
    try {
      useLoading().openLoading();
      await newResourceHTTP({ file: file.value });
      useMessageSuccess().open(`Los datos se guardaron existosamente!`);
      closeModal();
    } catch (err) {
      useMessageError().open(`Ha ocurrido un error al intentar guardar los datos.`);
    } finally {
      useLoading().closeLoading();
      await firstRecurso();
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  margin: 5%;
}

.el-form {
  margin-top: 0;
}

/* Elimina los márgenes de los el-form-item */
.el-form-item {
  margin-top: 0;
  margin-bottom: 0;
}
.input-margin {
  margin-top: 3%;
}
.full-width {
  width: 100%;
}
.custom-label {
  font-weight: 700;
  color: #111;
}
</style>
